import React from "react";
import { Form, FormGroup, Input, Label } from "reactstrap";

const CustomFilters = (props) => {
    const { onlyActiveFilterLabel, onlyActiveOnChange, showOnlyActiveFilter } = props;
    return (
        <div>
            {showOnlyActiveFilter ?         
                <Form>
                    <FormGroup
                    check
                    inline
                    >
                        <Input 
                        type="checkbox" 
                        id="onlyActiveCheckbox"
                        onChange={onlyActiveOnChange}
                        />
                        <Label check style={{ fontSize: 12 }} htmlFor="onlyActiveCheckbox">
                            <strong>{onlyActiveFilterLabel}</strong>
                        </Label>
                    </FormGroup>
                </Form> 
                : 
                <></>
            }
        </div>
    )
}

export default CustomFilters;